<template>
  <button
    class="group relative cursor-pointer items-center gap-x-2 rounded-xl bg-gradient-to-r from-primary via-indigo-600 to-purple-600 px-4 py-2 text-sm font-semibold text-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:ring-offset-2"
    :class="[onMobile ? 'inline-flex sm:hidden' : 'hidden sm:inline-flex']"
    @click.prevent="showSubscriptionModal"
  >
    <!-- Animated gradient overlay on hover -->
    <div class="absolute inset-0 bg-gradient-to-r from-primary/80 via-indigo-500/80 to-purple-500/80 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
    
    <!-- Pulsing indicator -->
    <span class="relative flex size-3">
      <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-yellow-300 opacity-75" />
      <span class="relative inline-flex size-3 rounded-full bg-yellow-400 shadow-sm" />
    </span>
    
    <!-- Text with better typography -->
    <span class="relative font-bold tracking-wide">
      {{ t('Upgrade subscription') }}
    </span>
    
    <!-- Subtle shine effect -->
    <div class="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-out" />
  </button>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const {
  showSubscriptionModal,
} = inject('subscriptionModal');

withDefaults(defineProps<{
  onMobile?: boolean
}>(), {
  onMobile: false,
});
</script>
